module.exports = __webpack_public_path__ + "img/bg-green-og.16cdab41.png";